import {
  TwitterWhite,
  LinkedinWhite,
  InstagramWhite,
  LinkWhite,
  FacebookWhite,
} from 'assets/icons';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';

export const advisorData: Record<string, unknown> = {
  phil: {
    image: getCompressedAssetUrl('/advisors/cutouts/phil.png'),
    thumb: 'advisors/blackWhite/philip.png/w_500',
    circleThumb: getCompressedAssetUrl('/advisors/thumbs/circle/phil.png'),
    title: 'Dr. Philip Ovadia',
    subtitle:
      'Board-certified cardiothoracic surgeon, founder of Ovadia Heart Health',
    links: [
      {
        title: <TwitterWhite />,
        href: 'https://twitter.com/ifixhearts',
      },
      {
        title: <LinkedinWhite />,
        href: 'https://www.linkedin.com/in/philip-ovadia-heart-health',
      },
      {
        title: <InstagramWhite />,
        href: 'https://www.instagram.com/ovadia_heart_health/?hl=en',
      },
      {
        title: <LinkWhite />,
        href: 'https://ovadiahearthealth.com',
      },
    ],
    description: (
      <>
        <p className="quote">
          I am elated to be partnering with Ultrahuman to revolutionize
          metabolic health centered care
        </p>
        <p>
          Dr. Philip Ovadia is a board-certified cardiothoracic surgeon, the
          founder of Ovadia Heart Health, a founding member of the Society of
          Metabolic Health Practitioners and the author of “Stay Off My
          Operating Table”. With multiple decades of experience in the
          healthcare industry, Dr. Ovadia has helped optimise the public&apos;s
          metabolic health and improve their quality of life.
        </p>
      </>
    ),
    related: ['howard', 'hanz', 'joel'],
  },
  howard: {
    image: getCompressedAssetUrl('/advisors/cutouts/howard.png'),
    thumb: 'advisors/blackWhite/howard.png/w_500',
    circleThumb: getCompressedAssetUrl('/advisors/thumbs/circle/howard.png'),
    title: 'Dr. Howard Luks',
    subtitle:
      'Board-certified orthopaedic surgeon, specializes in sports medicine',
    links: [
      {
        title: <FacebookWhite />,
        href: 'https://www.facebook.com/Howard.Luks.MD',
      },
      {
        title: <TwitterWhite />,
        href: 'https://twitter.com/hjluks',
      },
      {
        title: <LinkedinWhite />,
        href: 'https://www.linkedin.com/in/howardluksmd',
      },
      {
        title: <LinkWhite />,
        href: 'https://www.howardluksmd.com',
      },
    ],
    description: (
      <>
        <p className="quote">
          The path to metabolic fitness is achievable without unsustainable
          elimination diets, useless health supplements and heart-pounding
          exercise that may be too challenging to endure. Ecstatic to join the
          team at Ultrahuman to build on this mission
        </p>
        <p>
          Dr. Howard Luks is a board-certified orthopaedic surgeon and
          specializes in sports medicine. As the Chief of Sports Medicine and
          Arthroscopy at New York Medical College for over 20 years, he is
          highly knowledgeable in the field of sports medicine treatment for
          athletes of all ages. He is also a metabolic health advocate and is on
          the constant lookout for improving longevity.
        </p>
      </>
    ),
    related: ['phil', 'hanz', 'joel'],
  },
  hanz: {
    image: getCompressedAssetUrl('/advisors/cutouts/hanz.png'),
    thumb: 'advisors/blackWhite/hans.png/w_500',
    circleThumb: getCompressedAssetUrl('/advisors/thumbs/circle/hanz.png'),
    title: 'Prof. Hans-Peter Kubis',
    subtitle: 'Senior Lecturer in Physiology at the Bangor University, UK',
    links: [],
    description: (
      <>
        <p className="quote">
          The Ultrahuman system allows us to self-monitor the link between
          glucose homeostatic changes and our nutritional habits and may open
          our eyes to a better diet and lifestyle.
        </p>
        <p>
          Hans-Peter Kubis is a Senior Lecturer in Physiology at the School of
          Human and Behavioural Sciences, Bangor University, United Kingdom. He
          is an international recognized specialist in skeletal muscle
          adaptation to exercise and nutritional stimuli on cellular and
          whole-body levels, as well as in metabolic homeostasis with over 30
          years of research experience. Recent research has been dedicated to
          physiological and psychological determinants of physical activity
          behaviour. Currently, he is investigating the influence of aerobic
          fitness on body weight regulation i.e., influence on appetite and
          craving. In addition, he investigates mechanisms of effort and fatigue
          in various diseases.
        </p>
      </>
    ),
    related: ['phil', 'howard', 'joel'],
  },
  joel: {
    image: getCompressedAssetUrl('/advisors/cutouts/joel.png'),
    thumb: 'advisors/blackWhite/joel.png/w_500',
    circleThumb: getCompressedAssetUrl('/advisors/thumbs/circle/joel.png'),
    title: 'Joel Goldsmith',
    subtitle: 'Ex-Senior director, digital platforms at Abbott Diabetes Care',
    links: [],
    description: (
      <>
        <p className="quote">
          I&rsquo;m thrilled to be helping the Ultrahuman team increase
          awareness of metabolic health and expand access to CGM technology.
        </p>
        <p>
          Mr. Joel Goldsmith has worked in the medical technology industry for
          over 20 years, and is a pioneer in the field of digital health. Most
          recently, he was Senior Director, Digital Platforms at Abbott Diabetes
          Care, the world&rsquo;s leading CGM manufacturer. He was one of the
          inventors of the FreeStyle Libre biosensing platform, which disrupted
          the glucose monitoring category and is used by over 4 million people
          globally. Before joining Abbott he was a Biodesign Innovation Fellow
          at Stanford University, and also worked at Medtronic. He has a
          bachelor&rsquo;s degree in Neuroscience from the University of
          Pennsylvania and an MBA from the UCLA Anderson School of Management
        </p>
      </>
    ),
    related: ['phil', 'howard', 'hanz'],
  },
};

export const getAdvisorData = (advisorId: string) => {
  return advisorData[advisorId];
};

export const isAdvisorAvailable = (advisorId: string) => {
  return Object.keys(advisorData).includes(advisorId);
};
